(function () {
  'use strict';

  angular.module('sempraWebapp').service('dialogsService', dialogsService);

  /** @ngInject */
  function dialogsService ($mdDialog, $translate) {
    this.showConfirmDialog = function (titleKey, textKey, actionKey) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant(titleKey))
        .textContent($translate.instant(textKey))
        .ariaLabel($translate.instant(actionKey))
        .ok($translate.instant(actionKey))
        .cancel($translate.instant('CANCEL'));

      return $mdDialog.show(confirm);
    };
    this.showConfirmTitleDialog = function (titleKey, actionKey) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant(titleKey))
        .ariaLabel($translate.instant(actionKey))
        .ok($translate.instant(actionKey))
        .cancel($translate.instant('CANCEL'));

      return $mdDialog.show(confirm);
    };
    this.showOkDialog = function (titleKey, textKey) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant(titleKey))
        .textContent($translate.instant(textKey))
        .ok($translate.instant('OK'));

      return $mdDialog.show(confirm);
    };
  }
})();
